// FILE: /src/Components/Public/PageSelectionView.js (NEW FILE)

import React, { useState } from 'react';
import { Button, Checkbox, List, Avatar } from 'antd';

const PageSelectionView = ({ accounts, platformName, onFinalize, onCancel, accountNameKey = 'name', accountImageKey = 'profile_picture_url' }) => {
    const [selectedItems, setSelectedItems] = useState([]);

    const handleItemSelect = (item, isChecked) => {
        setSelectedItems(prev =>
            isChecked ? [...prev, item] : prev.filter(i => i.id !== item.id)
        );
    };

    const getImage = (account) => {
        // This function gracefully handles different image URL structures from various APIs
        if (typeof accountImageKey === 'function') {
            return accountImageKey(account);
        }
        return account[accountImageKey] || account.picture?.data?.url;
    };
    
    return (
        <div className="flex justify-center items-center min-h-screen bg-gray-50 p-4">
            <div className="w-full max-w-lg bg-white p-6 rounded-lg shadow-lg">
                <h3 className="text-xl font-semibold mb-2">Select {platformName} Accounts</h3>
                <p className="text-gray-500 mb-4">Choose which accounts you'd like to connect.</p>
                <div className="h-72 overflow-y-auto border rounded-lg p-2">
                    <List
                        dataSource={accounts}
                        renderItem={acc => (
                            <List.Item
                                key={acc.id}
                                actions={[
                                    <Checkbox
                                        onChange={(e) => handleItemSelect(acc, e.target.checked)}
                                        checked={selectedItems.some(i => i.id === acc.id)}
                                    />
                                ]}
                            >
                                <List.Item.Meta
                                    avatar={<Avatar src={getImage(acc)} />}
                                    title={<span className="font-semibold">{acc[accountNameKey] || acc.username}</span>}
                                />
                            </List.Item>
                        )}
                        locale={{ emptyText: "No accounts found." }}
                    />
                </div>
                <div className="flex justify-end gap-2 mt-4">
                    <Button key="back" onClick={onCancel}>Cancel</Button>
                    <Button key="submit" type="primary" onClick={() => onFinalize(selectedItems)} disabled={selectedItems.length === 0}>
                        Connect ({selectedItems.length})
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default PageSelectionView;